(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['$anchorScroll', '$q', '$state', '$stateParams', '$scope', 'authentication', 'moment', '_', 'config'];

    function ProfileController($anchorScroll, $q, $state, $stateParams, $scope, authentication, moment, _, config) {
        var vm = this;
        var oldCommunity = {
            communityAffiliationId: null,
            communityAffiliationName: null
        };

        vm.phoneRegex = null;
        vm.isUatWebsite = null;
        vm.isTrainingWebsite = null;
        vm.isLoading = true;

        vm.roles = [];

        vm.dispositions = {};
        vm.dispositionsSelected = 0;
        vm.masterUserId = parseInt($stateParams.id) || null; // If exists, using page as admin
        vm.nonUserEmail = $stateParams.email || null; // If exists, using page to create non-user
        vm.fullName = vm.nonUserEmail || "";

        vm.noProfile = false;

        vm.onSubmit = onSubmit;
        vm.onCancel = onCancel;
        vm.onChangeDisposition = onChangeDisposition;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.phoneRegex = configData.phoneRegex;
                vm.isUatWebsite = configData.isUatWebsite;
                vm.isTrainingWebsite = configData.isTrainingWebsite;
            });
            fillDropDowns().then(getUserProfile);
        }

        function fillDropDowns() {
            var promiseArray = [];

            vm.dropDowns = {};

            promiseArray.push(authentication.getArmyComponents().then(function (response) {
                vm.dropDowns.components = response.values;
            }));

            promiseArray.push(authentication.getBranchOfServices().then(function (response) {
                vm.dropDowns.branches = response.values;
            }));

            promiseArray.push(authentication.getPayGrades().then(function (response) {
                vm.dropDowns.ranks = response.values;
            }));

            promiseArray.push(authentication.getCivilianPayGrades().then(function (response) {
                vm.dropDowns.civilianRanks = response.values;
            }));

            promiseArray.push(authentication.getDispositions().then(function (response) {
                response.values.forEach(function (disposition) {
                    vm.dispositions[disposition] = {
                        name: disposition,
                        selected: false,
                        disabled: false
                    };
                });
            }));

            promiseArray.push(authentication.getCommunities({
            }).then(function (response) {
                vm.dropDowns.communities = response.communityAffiliations;
            }));

            return $q.all(promiseArray).catch(function (error) {
                vm.formSuccess = '';
                vm.formError = "Error: " + error;
            });
        }

        function getUserProfile() {
            vm.isLoading = true;

            var params = null;

            var getUserProfilePromiseArray = [];
            var commCheckPromiseArray = [];

            getUserProfilePromiseArray.push(authentication.getUserProfile(params)
                .then(function (response) {
                    // If editing own profile and a part is incomplete (not checking admin profile)
                    if (!authentication.isAosProfileValid(response.aosUser)) {
                        vm.noProfile = true;
                        vm.formSuccess = '';
                        vm.formError = "You must enter data in all required fields in order to update your AFWP profile. Note that some or all of this data is used by other AFWP systems.";

                        vm.initialDate = moment().format('MM/DD/YYYY');
                    }

                    vm.email = response.masterUserEmail || response.aosUser.email;

                    var aosProfile = response.aosUser;

                    vm.fullName = aosProfile.firstName + " " + aosProfile.lastName;

                    vm.aosProfile = {};
                    vm.aosProfile.firstName = aosProfile.firstName || '';
                    vm.aosProfile.middleInitial = aosProfile.middleInitial ? aosProfile.middleInitial : '';
                    vm.aosProfile.lastName = aosProfile.lastName || '';
                    vm.aosProfile.dateOfBirth = aosProfile.dateOfBirth ? moment(aosProfile.dateOfBirth, 'YYYY-MM-DD').toDate() : undefined;


                    if (aosProfile.communityAffiliationId) {
                        commCheckPromiseArray.push(authentication.isCommunityArchived(aosProfile.communityAffiliationId)
                            .then(function (isArchived) {
                                if (isArchived) {
                                    vm.formSuccess = '';
                                    vm.formError = "The Military Community you were a part of has been inactivated. Please select a new one.";
                                }
                            })
                        );

                        oldCommunity = vm.aosProfile.militaryCommunity = vm.dropDowns.communities.filter(function (comm) {
                            return comm.communityAffiliationId === aosProfile.communityAffiliationId;
                        })[0];
                    }
                    else {
                        vm.aosProfile.militaryCommunity = oldCommunity = undefined;
                    }

                    vm.aosProfile.branch = aosProfile.branchOfService || '';
                    vm.aosProfile.component = aosProfile.armyComponent || '';

                    if (aosProfile.dispositions) {
                        aosProfile.dispositions.forEach(function (disposition) {
                            vm.dispositions[disposition].selected = true;
                            onChangeDisposition(vm.dispositions[disposition]);
                        });

                        if (vm.dispositions['Service Member'].selected) {
                            vm.aosProfile.rank = aosProfile.payGrade;
                        }
                        if (vm.dispositions['Family Member'].selected) {
                            vm.aosProfile.sponsorRank = aosProfile.sponsorPayGrade;
                        }
                        if (vm.dispositions['DoD Civilian'].selected) {
                            vm.aosProfile.civilianRank = aosProfile.civilianPayGrade;
                        }
                    }

                    if(aosProfile.aosRoles.length > 0){
                        aosProfile.aosRoles.forEach(function(aosRole){
                           if(aosRole === "AFWP Administrator"){
                               vm.roles.push(aosRole);
                           }
                        });
                    }
                })
                .catch(function (error) {
                    vm.formSuccess = '';
                    vm.formError = "Error: " + error;
                    vm.isLoading = false;
                }));

            commCheckPromiseArray.push(authentication.getCasInfoForUser(authentication.getEmail()).then(function (casInfo) {
                if(casInfo.user.admin){
                    vm.roles.push("CAS Administrator");
                }
            })
            .catch(function (error) {
                vm.formSuccess = '';
                vm.formError = "Error: " + error;
                vm.isLoading = false;
            }));

            return $q.all(getUserProfilePromiseArray)
                .then(function () {
                    return $q.all(commCheckPromiseArray)
                        .then(function () {
                            vm.isLoading = false;
                        });

                });
        }

        function onSubmit() {
            setUserProfile();
        }

        function setUserProfile() {
            var aosUser = {
                firstName: vm.aosProfile.firstName,
                middleInitial: vm.aosProfile.middleInitial,
                lastName: vm.aosProfile.lastName,
                dateOfBirth: moment(vm.aosProfile.dateOfBirth).format('YYYY-MM-DD'),
                communityAffiliationId: vm.aosProfile.militaryCommunity.communityAffiliationId,
                branchOfService: vm.aosProfile.branch,
                armyComponent: vm.aosProfile.component,
                dispositions: []
            };

            angular.forEach(vm.dispositions, function (disposition) {
                if (disposition.selected) aosUser.dispositions.push(disposition.name);
            });

            if (vm.dispositions['Service Member'].selected) {
                aosUser.payGrade = vm.aosProfile.rank;
            }
            if (vm.dispositions['Family Member'].selected) {
                aosUser.sponsorPayGrade = vm.aosProfile.sponsorRank;
            }
            if (vm.dispositions['DoD Civilian'].selected) {
                aosUser.civilianPayGrade = vm.aosProfile.civilianRank;
            }

            var promise = $q.resolve();
            promise.then(function () {
                return authentication.setUserProfile(aosUser);
            }).then(function () {
                oldCommunity = vm.aosProfile.militaryCommunity;
                vm.formError = '';
                vm.formSuccess = 'Profile updated successfully!';
                // Alert header and side nav to update for any possible changes if not admin editing
                if (!vm.masterUserId)
                    $scope.$emit('profile:update');
                // Just update profile page header if admin editing
                else
                    vm.fullName = aosUser.firstName + " " + aosUser.lastName;
            }).catch(function (error) {
                vm.formSuccess = '';
                vm.formError = "Error: " + error;
            }).finally(function () {
                $anchorScroll('anchor-top');
            });
        }

        function onCancel() {
            $state.go('accountManagement.dashboard', null, { reload: true });
        }

        function onChangeDisposition(disposition) {
            vm.dispositionsSelected += disposition.selected ? 1 : -1;
        }
    }
})();